
import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';

import { FormGroup, Validators, FormBuilder,FormControl, FormGroupDirective, NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import {ErrorStateMatcher} from '@angular/material/core';
import {AuthService}from '../../../../auth-guard/auth.service';
import { invalid } from '@angular/compiler/src/render3/view/util';
import { ReplaySubject, Subject, from } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
interface  shipingarr  {};
class CrossFieldErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return control.dirty && form.invalid;
  }
}


@Component({
  selector: 'app-fccp-registeration',
  templateUrl: './fccp-registeration.html',
//   styleUrls:['./fccp-layout.scss']
})

export class FccpRegisteration implements OnInit {

    regform: FormGroup;
    regformemail: FormGroup;
    regformpwd: FormGroup;
    scacverifyfm: FormGroup;
    errorMatcher = new CrossFieldErrorMatcher();
    emailver = false;
    showcard:boolean=true;
    shipingarr:any=[];
    paramdata:any;
    showerror:any=false;
    hide:any;
    hide1:any;
    truckeremail:any='';
    truckername:any='';
    private _onDestroy = new Subject<void>();
    public filtered_shiping: ReplaySubject<shipingarr[]> = new ReplaySubject<shipingarr[]>(1);
    

  constructor(private fb: FormBuilder, private router: Router,private authservice:AuthService) {
    this.hide = true;
    this.hide1= true;
    this.scacverifyfm=this.fb.group({
      scac_verify : ['', [Validators.required]],
    });

    this.intform();
    this.regformemail.get('email').setErrors({'existerror':true});
    this.getshiping();
  
  }

  intform(){
    this.regform = this.fb.group({
      fl_name : '',
      last_name : '',
    scac_name : ['', [Validators.required]],
    pool_name : ['FCCP', [Validators.required]],
 shippingline : ['', []],
  shipping_line_ctrl:'',
});
  this.regformemail = this.fb.group({
                      email : ['', [Validators.required,Validators.email]],
                      conf_email : ['', [Validators.required]]
  },{
    validator: [this.emailmatch]
    });

  this.regformpwd = this.fb.group({
    password : ['', [Validators.required]],
    conf_password : ['', [Validators.required]]
  },{
    validator: [this.passwordValidator]
    });

  }

  ngOnInit() {
  
  }

  passwordValidator(form: FormGroup) {
    const condition = form.get('password').value !== form.get('conf_password').value;
    return condition ? { passwordsDoNotMatch: true} : null;
  }

  emailmatch(form: FormGroup) {
    const condition = form.get('email').value !== form.get('conf_email').value;
    return condition ? {emailDoNotMatch: true} : null;
  }

  emailverification()
  {
    var paramdata = {
                      user_email:this.regformemail.get('email').value
                    };
    this.authservice.selectdata('emailverification', paramdata).subscribe((resp:any) =>
    { 
      if(resp.length > 0)
      { 
        this.authservice.showToasterror('top-center', 'Email Already Exist ',5000) ;
        this.emailver = false;
        this.regformemail.get('email').setErrors({existerror:true});
      }
      else{
        this.emailver = true;
      }
      
    },
    onerror => 
    {
      console.log("Error man"); 
    });
  }

  generate()
  {
   return Math.floor(Math.random() * 9000) + 1000;
  }

  usersubmit()
  {
    var userdetails='action=pooluserverification&emailid='+ this.regformemail.get('email').value+'&';
    var paramdata={
      user_email:this.regformemail.get('email').value,
      first_name : this.regform.get('fl_name').value ,
      last_name: this.regform.get('last_name').value ,
      password_txt : this.regformpwd.get('password').value ,
      created_dt:new Date(),
      creater_id:"ADMIN",
      ver_code:this.generate(),
      user_status:"P",
      user_role: 'PC',
      user_scac: this.regform.get('scac_name').value,
      poolcode :this.regform.get('pool_name').value,
      shippingline :(this.regform.get('shippingline').value).toString(),
    };

    userdetails+='ver_code='+paramdata.ver_code+'&';
    // userdetails+='ver_filename='+this.authservice.imageurl+"cams2/#/fccp/fccpverification?emailid="+paramdata.user_email;
    userdetails+='ver_filename='+this.authservice.imageurl+"cams2/%23/fccp/fccpverification?emailid="+paramdata.user_email;
    // --------second emaildata---------
    var userdetail = this.authservice.getemailobjectstring({
      action:'poolusercreation',
      trucker_email : this.truckeremail,
      truckername : this.truckername,
      userdetails : this.regform.get('fl_name').value+'|'+this.regform.get('last_name').value+'|'+this.regformemail.get('email').value
                    +'|'+this.regform.get('pool_name').value+'|'+(this.regform.get('shippingline').value).toString()
    } );
    // --------second emaildata end-------  
    this.authservice.selectdata('fccpusercreate', paramdata).subscribe((resp:any) =>
    { 
      console.log(resp);
      if(resp.length > 0)
      { 
        console.log(resp);
        this.intform();
        this.scacverifyfm.get('scac_verify').reset();
        this.showcard=true; 
// --------second emaildata end-------  
        this.authservice.sendemailurlresp('_jsusercreation.php?',userdetail,'json').subscribe((getData:any) => 
        {
              if (   getData > 0 )    
              {

                // this.authservice.showSuccess('top-full-width','Check Your Email And Enter OTP Received',10000) ;  
              }
             else 
              {
               
                this.authservice.showToasterror('top-center','Problem Email Sending.Please Contact Customer Service',10000) ;
               
              }
        },
        onerror => 
        {
              this.authservice.showToasterror('top-full-width','Problem In Data Insertion.Please Contact Customer Service',10000) 
        });

        this.authservice.sendemailurlresp('_jsusercreation.php?',userdetails,'json').subscribe((getData:any) => 
                {
                      if (   getData > 0 )    
                      {

                        this.authservice.showSuccess('top-center','Check Your Email And Enter OTP Received',10000) ;  
                        
                      }
                     else 
                      {
                        console.log("Data Not Inserted"); 
                        this.authservice.showToasterror('top-center','Problem Email Sending.Please Contact Customer Service',10000) ;
                       
                      }
                },
                onerror => 
                {
                      this.authservice.showToasterror('top-full-width','Problem In Data Insertion.Please Contact Customer Service',10000) 
                });
      }
      else{
      
      }
      
    },
    onerror => 
    {
      console.log("Error man"); 
    });
  }

  gotologin()
  {
    this.router.navigate(['/fccp/fccplogin']);
  }

 

getshiping()
{
      this.paramdata={};
      this.paramdata.category='FCCPSSL'; 

      this.authservice.selectdata('getreferencecodes', this.paramdata).subscribe((getData:any) =>
      { 
        console.log(getData);
        this.shipingarr=getData
        this.controllervaluechange(this.shipingarr ,'shipping_line_ctrl',this.filtered_shiping );
        this.regform.get('shippingline').setValue(['ONEY']);
      },
      onerror => 
      {
      console.log("Error man"); 
      });

 }

controllervaluechange(elementdata,ctrlname,filteredvar )
{
  filteredvar.next(elementdata.slice());
  this.regform.get(ctrlname).valueChanges
              .pipe(takeUntil(this._onDestroy))
              .subscribe(() => {
                this.filterdata(elementdata,ctrlname,filteredvar );
              });
}

filterdata(elementdata,ctrlname,filteredvar)
{

      if (! elementdata) {
          return;
        }
        // get the search keyword
        let search = this.regform.get(ctrlname).value;


        if (!search) {
          filteredvar.next( elementdata.slice());
          return;
        } else {
          search = search.toLowerCase();
        }
        
          if(ctrlname=='shipping_line_ctrl')
          {
            filteredvar.next(
              elementdata.filter(shiping_data => (shiping_data.codetxt).toLowerCase().indexOf(search) > -1)
            );
          }
      
    
    
}


validate_scac()
{
  if(this.scacverifyfm.get('scac_verify').value=='AIMA')
  {
    console.log('invalid scac');
    this.showerror=true
   this.scacverifyfm.get('scac_verify').reset();
  }
  else{
  this.truckeremail ='';
  this.truckername='';

   this.paramdata={};
   this.paramdata.scac_code = this.scacverifyfm.get('scac_verify').value;
  
  
   // console.log('toscac result',paramdata);

  this.authservice.selectdata('aimtrack_validate_truckcode',this.paramdata).subscribe((data:any) => 
  {
      if(data.length>0)
      { 
          console.log(data);
          console.log('trucker name'+data[0].truckname+'truker email'+data[0].email_address);
          this.truckeremail = data[0].email_address;
          this.truckername  = data[0].truckname;
          this.regform.get('scac_name').disable();
          this.showcard=false;
          this.showerror=false;
          this.regform.get('scac_name').setValue(this.scacverifyfm.get('scac_verify').value);

      }
    else
      {
          console.log('invalid scac');
           this.showerror=true
          this.scacverifyfm.get('scac_verify').reset();
          // this.service.showToast("top","You Enter Invalid Transfer SCAC","warning" );
         
      }
        
       },
     onerror => {
           console.log("Error man"); 
    });
  }
 
 }


}

